(() => {
  const root = document.documentElement;
  const motionReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  document.querySelectorAll('[data-nb-color]').forEach((button) => {
    button.addEventListener('click', () => {
      const { hue, saturation, brightness, color, label } = button.dataset;
      root.style.setProperty('--nb-hue', `${hue}deg`);
      root.style.setProperty('--nb-saturation', saturation);
      root.style.setProperty('--nb-brightness', brightness);
      root.style.setProperty('--nb-active', color);
      document.querySelectorAll('[data-nb-color]').forEach((item) => item.setAttribute('aria-pressed', 'false'));
      button.setAttribute('aria-pressed', 'true');
      document.querySelectorAll('[data-nb-color-status]').forEach((item) => { item.textContent = `Color seleccionado: ${label}`; });
    });
  });
  if (!motionReduced && 'IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-visible'); observer.unobserve(entry.target); } }), { threshold:.14 });
    document.querySelectorAll('.nb-reveal').forEach((element) => observer.observe(element));
  } else { document.querySelectorAll('.nb-reveal').forEach((element) => element.classList.add('is-visible')); }
})();
